if (!customElements.get('wk-film')) {
  customElements.define('wk-film', class extends HTMLElement {
    connectedCallback() {
      this.videos = [...this.querySelectorAll('video')];
      this.button = this.querySelector('.wk-film__control');
      if (!this.videos.length || !this.button) {
        this.contentObserver ??= new MutationObserver(() => {
          if (!this.querySelector('video') || !this.querySelector('.wk-film__control')) return;
          this.contentObserver.disconnect();
          this.connectedCallback();
        });
        this.contentObserver.observe(this, { childList: true, subtree: true });
        return;
      }
      this.contentObserver?.disconnect();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.userPaused ??= false;
      this.inView = false;
      this.motionPaused = this.reduced.matches || Boolean(navigator.connection?.saveData);
      this.button.hidden = false;
      this.videos.forEach(video => {
        video.muted = true;
        video.playsInline = true;
        video.tabIndex = -1;
        video.addEventListener('playing', () => {
          if (video !== this.activeVideo()) {
            video.pause();
            return;
          }
          video.dataset.ready = '';
          this.toggleAttribute('data-playing', true);
          this.label(true);
        }, options);
        video.addEventListener('pause', () => {
          if (video === this.activeVideo()) {
            this.removeAttribute('data-playing');
            this.label(false);
          }
        }, options);
      });
      this.button.addEventListener('click', () => {
        const video = this.activeVideo();
        if (!video) return;
        this.userPaused = !video.paused;
        if (video.paused) {
          this.motionPaused = false;
          this.play(video);
        }
        else video.pause();
      }, options);
      this.mobile.addEventListener('change', () => this.sync(), options);
      this.reduced.addEventListener('change', () => {
        this.motionPaused = this.reduced.matches;
        this.sync();
      }, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.sync();
      }, { threshold: 0.12 });
      this.observer.observe(this);
      this.sync();
    }
    activeVideo() {
      return this.mobile.matches
        ? this.querySelector('.wk-film__video--mobile') || this.querySelector('.wk-film__video--desktop')
        : this.querySelector('.wk-film__video--desktop');
    }
    label(playing) {
      const label = playing ? (this.dataset.pauseLabel || 'Pause video') : (this.dataset.playLabel || 'Play video');
      this.button.setAttribute('aria-label', label);
      this.button.title = label;
    }
    play(video) {
      video.play().catch(() => {
        if (video !== this.activeVideo() || !video.paused) return;
        this.removeAttribute('data-playing');
        this.label(false);
      });
    }
    sync() {
      const active = this.activeVideo();
      this.button.hidden = !active;
      this.videos.forEach(video => {
        if (video !== active || !this.inView || document.hidden || this.userPaused || this.motionPaused) video.pause();
      });
      this.toggleAttribute('data-playing', Boolean(active && !active.paused));
      this.label(Boolean(active && !active.paused));
      if (active && this.inView && !document.hidden && !this.userPaused && !this.motionPaused) this.play(active);
    }
    disconnectedCallback() {
      this.contentObserver?.disconnect();
      this.observer?.disconnect();
      this.abort?.abort();
      this.videos?.forEach(video => video.pause());
    }
  });
}
